import React from 'react';
import SadCalendar from '../../Images/sadCalendar.PNG';

function NoEvent() {
    
    return(
        <div style={{
            display:"flex",
            flexDirection:"column",
            justifyContent:"center",
            alignItems:"center",
            textAlign:"center",
            color:"#ffffff",
            fontFamily:"Raleway-SemiBold",
            fontSize:"Large"
        }}>
            <img src={SadCalendar} alt="No Events" style={{
                height:"50px",
                width:"50px",
                borderRadius:"4px",
                marginBottom:"30px",
                marginTop:"34vh"
            }}/>

            No Classes
        </div>
    );
}

export default NoEvent;